// extracted by mini-css-extract-plugin
export default {"headerStyles":"components-Header-themes-PP-stylesHeader__headerStyles--CG_4A"};